import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import Button from './Button';
const StartNowBanner = () => {
  const [isVisible, setIsVisible] = useState(true);
  // Optional: Hide banner after scrolling past a certain point
  useEffect(() => {
    const handleScroll = () => {
      // You can adjust this value based on when you want the banner to hide
      if (window.scrollY > 300) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed top-16 left-0 right-0 z-40 flex justify-center px-4" data-id="element-2263">
      <div className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg shadow-lg py-2 px-4 flex items-center justify-between max-w-4xl w-full border border-indigo-500" data-id="element-2264">
        <div className="text-sm md:text-base font-medium" data-id="element-2265">
          Ready to transform your retail experience with AI?
        </div>
        <a href="https://chat.shopilots.com/signup?product=shopilots" target="_blank" rel="noopener noreferrer" data-id="element-2266">
          <Button variant="primary" size="sm" className="bg-white text-indigo-700 hover:bg-indigo-50 whitespace-nowrap ml-4" data-id="element-2267">
            Start Now <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-2268" />
          </Button>
        </a>
      </div>
    </div>;
};
export default StartNowBanner;